<template>
  <div class="type-answer">
    <div class="question">
      <div class="title-in-bg" v-if="question.settings.questionDisplayStyle == 1" v-bind:style="question.media != null ? {backgroundImage: 'url('+question.media.value.src+')',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'} : {backgroundColor: question.settings.questionBackgroundColor}">
          <p :style="{color: question.settings.questionFontColor}">{{question.text}}</p>
      </div>
      <div class="title-out-bg" v-else-if="question.settings.questionDisplayStyle == 2">
          <p :style="{color: question.settings.questionFontColor}">{{question.text}}</p>
          <div class="img-question" v-if="question.media != null">
            <img :src="question.media.value.src" />
          </div>
      </div>
      <div class="title-only-image" v-else-if="question.settings.questionDisplayStyle == 3">
          <div class="img-question" v-if="question.media != null">
            <img :src="question.media.value.src" />
          </div>
      </div>
      <div class="title-only-text" v-else>
          <p :style="{color: question.settings.questionFontColor}">{{question.text}}</p>
      </div>
      <div 
        class="send-answer"
        v-bind:class="[
          answer[index].num == question.answers.length ? 'disable' : '',
          answer[index].data.length > 0 && answer[index].correct == 1 ? 'correct' : '',
          answer[index].data.length > 0 && answer[index].correct == 0 ? 'in-correct' : ''
        ]"
      >
        <input placeholder="Nhập câu trả lời của bạn ..." v-model="valAnswer" />
        <div class="icon-correct" v-if="answer[index].data.length > 0 && answer[index].correct == 1">
          <Correct />
        </div>
        <div class="icon-in-correct" v-if="answer[index].data.length > 0 && answer[index].correct == 0">
          <InCorrect />
        </div>
        <div class="btn-send" @click="sendAnswer(question)">Gửi câu trả lời</div>
      </div>

      <div v-if="showResult">
        <div v-if="answer[index].correct == 1" class="show-correct">
          <div class="info">
            <div class="icon">
              <Correct />
            </div>
            <span>Chính xác</span>
          </div>
          <div class="description" v-if="question.correct_note.text != ''">{{question.correct_note.text}}</div>
          <div class="image-question" v-if="question.correct_note.media != null">
            <img :src="question.correct_note.media.value.src" />
          </div>
        </div>
        <div v-if="answer[index].correct == 0" class="show-in-correct">
          <div class="info">
            <div class="icon">
              <InCorrect />
            </div>
            <span>Không chính xác</span>
          </div>
          <div class="description" v-if="question.correct_note.text != ''">{{question.correct_note.text}}</div>
          <div class="image-question" v-if="question.correct_note.media != null">
            <img :src="question.correct_note.media.value.src" />
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import InCorrect from '../../ui/icons/svgs/icons/InCorrect'
import Correct from '../../ui/icons/svgs/icons/Correct'
export default {  
  name: "TypeAnswer",
  props: ['question', 'index', 'showResult'],
  components: {
    InCorrect,
    Correct
  },
  data: function(){
    return{
      valAnswer: ''
    }
  },
  computed: {
    answer: function(){
      if (this.$store.getters.numQuestionFinish == 0){
        this.valAnswer = ""
      }
      return this.$store.getters.defaultAnswer
    }
  },
  methods: {
    sendAnswer(question){
      const info = {
        question_id: question.id,
        value: this.valAnswer
      }
      this.$store.dispatch('sendAnswer',info)
    }
  }
};
</script>

<style lang="scss">
  .type-answer{
    .title-in-bg{
      display: flex;
      margin-bottom: 10px;
      align-items: center;
      border-radius: 8px;
      font-weight: bold;
      min-height: 116px;
      font-size: 32px;
      line-height: 36px;
      justify-content: center;
      text-align: center;
      padding: 44px 60px;
      color: #FFFFFF;
    }
    .title-out-bg{
      display: flex;
      margin-bottom: 10px;
      align-items: center;
      flex-wrap: wrap;
      border-radius: 8px;
      font-weight: bold;
      color: #333333;
      justify-content: left;
      text-align: left;
      font-size: 26px;
      line-height: 31px;
      .img-question{
        width: 100%;
        margin-top: 10px;
        img{
          width: 100%;
          border-radius: 8px;
        }
      }
    }
    .title-only-image{
      width: 100%;
      margin-bottom: 10px;
      .img-question{
        width: 100%;
        img{
          width: 100%;
          border-radius: 8px;
        }
      }
    }
    .title-only-text{
      margin-bottom: 10px;
      p{
        font-weight: bold;
        font-size: 26px;
        line-height: 31px;
      }
    }
    .send-answer{
      position: relative;
      input{
        width: calc(100% - 6px);
        height: 38px;
        text-align: center;
        background: #F4F4F4;
        border-radius: 8px;
        border: none;
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        color: #333333;
        border: 3px solid #F4F4F4;
      }
      input:focus{
        outline: none;
      }
      .btn-send{
        cursor: pointer;
        height: 44px;
        width: 100%;
        margin-top: 10px;
        background: #0F62FE;
        border: 1px solid rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        color: #FFFFFF;
      }
      .icon-correct{
        background: #24A148;
        width: 24px;
        height: 24px;
        position: absolute;
        top: 10px;
        right: 10px;
        border-radius: 50%;
        display: none;
        align-items: center;
        justify-content: center;
        svg{
            width: 10px;
            fill: #fff;
        }
      }
      .icon-in-correct{
        background: #DA1E28;
        width: 24px;
        height: 24px;
        position: absolute;
        top: 10px;
        right: 10px;
        border-radius: 50%;
        display: none;
        align-items: center;
        justify-content: center;
        svg{
            width: 10px;
            fill: #fff;
        }
      }
    }
    .send-answer.correct{
      input{
        pointer-events: none;
        border: 3px solid green;
      }
      .icon-correct{
        pointer-events: none;
        display: flex;
      }
    }
    .send-answer.in-correct{
      input{
          border: 3px solid #DA1E28;
      }
      .icon-in-correct{
          display: flex;
      }
    }
    .show-correct{
      margin-top: 24px;
      padding: 16px;
      background: rgba(36, 161, 72, 0.05);
      border-radius: 8px;
      .info{
        display: flex;
        align-items: center;
        .icon{
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #24A148;
          display: flex;
          align-items: center;
          justify-content: center;
          svg{
            fill: #fff;
            width: 20px;
          }
        }
        span{
          font-weight: bold;
          font-size: 18px;
          line-height: 20px;
          color: #333333;
          margin-left: 12px;
        }
      }
      .description{
        font-size: 16px;
        line-height: 19px;
        color: #666666;
        margin: 16px 0;
      }
      .image-question{
        margin-top: 16px;
        width: 300px;
        // height: 160px;
        margin: auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .show-in-correct{
      margin-top: 24px;
      padding: 16px;
      background: linear-gradient(0deg, rgba(218, 30, 40, 0.05), rgba(218, 30, 40, 0.05)), #FFFFFF;
      border-radius: 8px;
      .info{
        display: flex;
        align-items: center;
        .icon{
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #DA1E28;
          display: flex;
          align-items: center;
          justify-content: center;
          svg{
            fill: #fff;
            width: 20px;
          }
        }
        span{
          font-weight: bold;
          font-size: 18px;
          line-height: 20px;
          color: #333333;
          margin-left: 12px;
        }
      }
      .description{
        font-size: 16px;
        line-height: 19px;
        color: #666666;
        margin: 16px 0;
      }
      .image-question{
        margin-top: 16px;
        width: 300px;
        // height: 160px;
        margin: auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .disable{
      pointer-events: none;
    }
  }
</style>